import { KeyValue } from '@/components/inspect/KeyValue';
import { CodeChip } from '@/components/primitives';
import { bytes, count, text, timestamp } from '@/lib/inspectFormat';
import type { NatsStream } from '@/types/inspect';

export function StreamCard({
  stream,
  selected,
  onSelect,
}: {
  stream: NatsStream;
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <div
      className="card"
      onClick={onSelect}
      style={{
        cursor: 'pointer',
        borderColor: selected ? 'var(--accent)' : undefined,
      }}
    >
      <div className="card-pad">
        <div className="row gap-8 mb-8">
          <div className="mono flex1" style={{ fontWeight: 600 }}>
            {stream.name}
          </div>
          {stream.isSealed ? <span className="badge badge-warn">sealed</span> : null}
          <span className="badge">{stream.storage}</span>
        </div>

        {stream.description ? <div className="tiny muted mb-8">{stream.description}</div> : null}

        <div className="row gap-8 mb-16" style={{ flexWrap: 'wrap' }}>
          {stream.subjects.map((subject) => (
            <CodeChip key={subject} icon="hash">
              {subject}
            </CodeChip>
          ))}
        </div>

        <div className="grid-2">
          <div className="kv">
            <KeyValue k="Retention" v={stream.retention} />
            <KeyValue k="Discard" v={stream.discard} />
            <KeyValue k="Replicas" v={stream.replicas} />
            <KeyValue k="Max age" v={text(stream.maxAge)} />
            <KeyValue
              k="Max bytes"
              v={stream.maxBytes == null ? 'unlimited' : bytes(stream.maxBytes)}
            />
            <KeyValue k="Direct get" v={stream.allowDirect ? 'allowed' : 'disabled'} />
          </div>
          <div className="kv">
            <KeyValue k="Messages" v={count(stream.messages)} />
            <KeyValue k="Size" v={bytes(stream.bytes)} />
            <KeyValue
              k="Sequences"
              mono
              v={`${count(stream.firstSeq)} → ${count(stream.lastSeq)}`}
            />
            <KeyValue k="Subjects" v={count(stream.numSubjects)} />
            <KeyValue k="Consumers" v={count(stream.consumerCount)} />
            <KeyValue k="Last message" v={timestamp(stream.lastAt)} />
          </div>
        </div>
      </div>
    </div>
  );
}
